import { Home } from "./Home";

import "./styles/exxpressmart.styles.css";

export const EXXM = () => {
	return <Home />;
};
